// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-container .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.customer-container .listing-header .title-div {
  font: normal normal bold 1.75rem/28px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.customer-container .listing-header .search-and-filter {
  display: flex;
  justify-content: flex-end;
}
.customer-container .listing-header .search-and-filter .filter-div {
  display: flex;
}
.customer-container .listing-header .search-and-filter .filter-div .filter-icon {
  display: flex;
  align-items: center;
  padding: 0 0.5625rem;
}
.customer-container .listing-header .search-and-filter .filter-div .filter-label {
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.customer-container .listing-table {
  padding: 0 0 1.25rem;
}
.customer-container .listing-table .table {
  width: 100%;
}
.customer-container .listing-table .table .column-heading {
  font-weight: 400;
  font-size: 0.975rem;
  line-height: 1rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.5625rem 0.5625rem 0.5625rem 0;
}
.customer-container .listing-table .table .status-col {
  max-width: 110px;
  width: 100px;
}
.customer-container .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.customer-container .listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.customer-container .listing-table .table .table-body .table-row td {
  padding: 0.5625rem 0.5625rem 0.5625rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.1875rem;
  color: var(--ion-color-primary-black);
}
.customer-container .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}
.customer-container .mobile-view-listing .order-container .order-card {
  background: var(--ion-color-primary-white);
  border: 1px solid var(--ion-color-primary-border);
  border-radius: 2px;
  margin: 0.625rem 0;
}
.customer-container .mobile-view-listing .order-container .order-card .order-card-col {
  padding-top: 0.9375rem;
}
.customer-container .mobile-view-listing .order-container .order-card .grid-label {
  font-weight: 400;
  font-size: 0.6875rem;
  line-height: 0.8125rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
}
.customer-container .mobile-view-listing .order-container .order-card .grid-values {
  padding-top: 0.1875rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.1875rem;
  color: var(--ion-color-secondary-blue);
}
.customer-container .mobile-view-listing .order-container .mobile-right-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-btn,
.pending,
.shipped,
.canceled {
  font-weight: 400;
  font-size: 0.8375rem;
  line-height: 1.125rem;
  border-radius: 4px;
  width: 100%;
}

.pending {
  background: rgba(109, 207, 246, 0.2);
  color: var(--ion-color-primary-blue);
}

.shipped {
  background: rgba(172, 219, 97, 0.25);
  color: var(--ion-color-green-100);
}

.canceled {
  background: rgba(233, 75, 75, 0.1);
  color: var(--ion-color-primary);
}

.shipping,
.partially-shipped {
  background: rgba(255, 121, 23, 0.17);
  color: var(--ion-color-primary-orange);
}

.order-card .status-btn {
  width: auto;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 0.875rem;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/app/components/customers/customers.component.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAAF;AAEE;EACC,+CAAA;EACA,qCAAA;EACA,0BAAA;AAAH;AAGE;EACC,aAAA;EACA,yBAAA;AADH;AAGG;EACC,aAAA;AADJ;AAGI;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;AADL;AAII;EACC,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,+BAAA;AAFL;AAQC;EACC,oBAAA;AANF;AAQE;EACC,WAAA;AANH;AAQG;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uCAAA;EACA,wCAAA;AANJ;AASG;EACC,gBAAA;EACA,YAAA;AAPJ;AAUG;EACC,gBAAA;EACA,gBAAA;AARJ;AAYI;EACC,wDAAA;AAVL;AAYK;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,qCAAA;AAVN;AAaK;EACC,aAAA;EACA,mBAAA;AAXN;AAuBG;EACC,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,kBAAA;AArBJ;AAuBI;EACC,sBAAA;AArBL;AAwBI;EACC,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;AAtBL;AAyBI;EACC,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sCAAA;AAvBL;AA2BG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAzBJ;;AAgCA;;;;EAIC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AA7BD;;AAgCA;EACC,oCAAA;EACA,oCAAA;AA7BD;;AAgCA;EACC,oCAAA;EACA,iCAAA;AA7BD;;AAgCA;EACC,kCAAA;EACA,+BAAA;AA7BD;;AAgCA;;EAEC,oCAAA;EACA,sCAAA;AA7BD;;AAiCC;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AA9BF;;AAkCA;EACC,yBAAA;AA/BD;;AAkCA;EACC,2BAAA;AA/BD","sourcesContent":[".customer-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 1.75rem /28px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\n\t\t.search-and-filter {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\n\t\t\t.filter-div {\n\t\t\t\tdisplay: flex;\n\n\t\t\t\t.filter-icon {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tpadding: 0 0.5625rem;\n\t\t\t\t}\n\n\t\t\t\t.filter-label {\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tline-height: 1.0625rem;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tletter-spacing: 0.3px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.listing-table {\n\t\tpadding: 0 0 1.25rem;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 1rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tpadding: 0.5625rem 0.5625rem 0.5625rem 0;\n\t\t\t}\n\n\t\t\t.status-col {\n\t\t\t\tmax-width: 110px;\n\t\t\t\twidth: 100px;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\t.table-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\t\ttd {\n\t\t\t\t\t\tpadding: 0.5625rem 0.5625rem 0.5625rem 0;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.mobile-view-listing {\n\n\t\t// display: none;\n\t\t.order-container {\n\t\t\t.order-card {\n\t\t\t\tbackground: var(--ion-color-primary-white);\n\t\t\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tmargin: 0.625rem 0;\n\n\t\t\t\t.order-card-col {\n\t\t\t\t\tpadding-top: 0.9375rem;\n\t\t\t\t}\n\n\t\t\t\t.grid-label {\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 0.6875rem;\n\t\t\t\t\tline-height: 0.8125rem;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\t}\n\n\t\t\t\t.grid-values {\n\t\t\t\t\tpadding-top: 0.1875rem;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\tcolor: var(--ion-color-secondary-blue);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.mobile-right-arrow {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n.status-btn,\n.pending,\n.shipped,\n.canceled {\n\tfont-weight: 400;\n\tfont-size: 0.8375rem;\n\tline-height: 1.125rem;\n\tborder-radius: 4px;\n\twidth: 100%;\n}\n\n.pending {\n\tbackground: rgba(109, 207, 246, 0.2);\n\tcolor: var(--ion-color-primary-blue);\n}\n\n.shipped {\n\tbackground: rgba(172, 219, 97, 0.25);\n\tcolor: var(--ion-color-green-100);\n}\n\n.canceled {\n\tbackground: rgba(233, 75, 75, 0.1);\n\tcolor: var(--ion-color-primary);\n}\n\n.shipping,\n.partially-shipped {\n\tbackground: rgba(255, 121, 23, 0.17);\n\tcolor: var(--ion-color-primary-orange);\n}\n\n.order-card {\n\t.status-btn {\n\t\twidth: auto;\n\t\tfont-weight: 500;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 0.875rem;\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
